/**
 * @name setDrawerButton
 * @description ドロワーナビの開閉
 * @param {Object} lenis Lenisインスタンス
 * @param {Object} html html要素
 * @param {Object} DrawerButton ドロワーボタン要素
 * @param {Object} Links アンカーリンク
 */
export function setDrawerButton(lenis) {
  let html = document.querySelector('html');
  let overlay = document.querySelector('.overlay');
  let drawerNav = document.querySelector('.drawerNav');
  let drawerButton = document.querySelector('.drawerButton');
  let links = document.querySelectorAll('a[data-anchor="true"]');
  if (!drawerButton) return;

  /**
   * @name navOpen
   * @description ドロワーナビを開く
   */
  const navOpen = () => {
    html.dataset.state = "navOpen";
    lenis.stop();
  }

  /**
   * @name navClose
   * @description ドロワーナビを閉じる
   */
  const navClose = () => {
    html.dataset.state = "";
    lenis.start();
    setTimeout(() => {
      drawerNav.scrollTop = 0;
    }, 1000);
  }

  // ドロワーボタンクリック時
  drawerButton.addEventListener("click", () => {
    html.dataset.state === "navOpen" ? navClose() : navOpen()
  });

  // アンカーリンククリック時
  links.forEach((link) => link.addEventListener("click", navClose))

  //「ESC」キー押下時
  document.addEventListener("keydown", (e) => e.key === "Escape" && navClose());

  // オーバーレイクリック時
  overlay.addEventListener("click", navClose);
};